import * as React from 'react';
import { TextField } from 'office-ui-fabric-react';
import { ValidationHelper } from '@app/Services/Validation';

export type ChangeDaysCountHandler = (newValue?: number) => void;
export type ChangeVacEntitlementHandler = (newValue?: number) => void;

export type ContractPartTimeSpecialBlockProps = {
    onChangeDaysCount: ChangeDaysCountHandler;
    onChangeVacEntitlement: ChangeVacEntitlementHandler;
    daysCount?: number;
    vacEntitlement?: number;
    className?: string;
    disabled?: boolean;
};

export class ContractPartTimeSpecialBlock extends React.PureComponent<ContractPartTimeSpecialBlockProps,{}>{
    private _store: ContractPartTimeSpecialBlockStore;

    constructor(props: ContractPartTimeSpecialBlockProps) {
        super(props);
        this._store = new ContractPartTimeSpecialBlockStore(props);
    }

    render(){
        return(
            <>
                <TextField
                    label="TZV Days Per Year"
                    maxLength={3}
                    required
                    onKeyPress={ValidationHelper.validateNumber}
                    value={this.props.daysCount? this.props.daysCount.toString() : ''}
                    onChange={this._store.onChangeDaysCount}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                {(this.props.daysCount && (this.props.daysCount > 365 ||this.props.daysCount < 1)) &&
                    <span className="ms-TextField-errorMessage errorMessage">Days Count must be between 1 and 365 </span>
                }
                <TextField
                    label="VacEntitlement"
                    onKeyPress={ValidationHelper.validateFloat}
                    maxLength={5}
                    suffix="%"
                    required
                    validateOnFocusOut
                    onGetErrorMessage={this.getErrorMessageForVacEntitlement}
                    value={this.props.vacEntitlement? (Math.round(Number(this.props.vacEntitlement) * 100000) / 1000).toString() : ''}
                    onChange={this._store.onChangeVacEntitlement}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
            </>
        );
    }

    private getErrorMessageForVacEntitlement = (value: string): string => {
        if (value && (parseFloat(value) > 100)) {
            return 'Max value is 100%';
        }
        return '';
    };
}

class ContractPartTimeSpecialBlockStore {
    private readonly _onChangeDaysCountHandler: ChangeDaysCountHandler;
    private readonly _onChangeVacEntitlementHandler: ChangeVacEntitlementHandler;

    constructor(props: ContractPartTimeSpecialBlockProps) {
        this._onChangeDaysCountHandler = props.onChangeDaysCount;
        this._onChangeVacEntitlementHandler = props.onChangeVacEntitlement;
    }

    onChangeDaysCount = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        this._onChangeDaysCountHandler(Number(newValue) || undefined);
    };

    onChangeVacEntitlement = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        this._onChangeVacEntitlementHandler((Number(newValue) / 100) || undefined);
    };

}